import { query, mutation } from '@/dex-shared/helpers/graphql';

export default {
  state: {
    solution: {},
  },
  mutations: {
    SET_SOLUTION(state: any, solution: any) {
      state.solution = solution;
    },
    SET_EMPTY_SOLUTION(state: any, mutations: any) {
      let solution = {
        id: null,
        content: [
          {
            content: '',
            behavior: 'text',
          },
        ],
        questionId: null,
        userId: null,
      };
      state.solution = solution;
    },
  },
  actions: {
    async PULL_SOLUTION(
      { commit, state, rootState, getters }: any,
      solutionId: number,
    ) {
      const userId = rootState.auth.user.id;
      const response = await query(
        `query PullSolution($solutionId: Int!) {
                solutionById(id: $solutionId) {
                    id
                    content
                    questionId
                    userId
                }
            }`,
        {
          solutionId: +solutionId,
        },
      );
      let solution = response.data.solutionById;
      if (solution != null) {
        commit('SET_SOLUTION', solution);
      } else {
        commit('SET_EMPTY_SOLUTION');
      }
    },

    async REMOVE_SOLUTION({ commit }: any, solutionId: number) {
      try {
        let response = await mutation(
          `mutation deleteSolution($solutionId: Int!) {
            deleteSolutionById(input:{
              id: $solutionId
            }) {
              solution {
                id
              }
            }
          }`,
          {
            solutionId: +solutionId,
          },
        );
        return true;
        //TODO call the commit directly
      } catch (err) {
        return err;
      }
    },
  },
};
